import React from 'react'
import './home.scss'
import VideoIntro from '../Components/LandingPageComponents/VideoIntro';
import selfi from '../images/selfi.jpg';
import Brain from '../images/brain.jpg';
import { Link } from 'react-router-dom';
import Nav from '../Components/MainPageComponents/Nav';
import Layout from '../Components/MainPageComponents/Layout';
// import MailchimpSubscriptionForm from '../Components/auth/MailchimpSubscriptionForm';
import { BsLinkedin } from "react-icons/bs";
import { BsYoutube } from "react-icons/bs";
import { GrContact } from "react-icons/gr";
import { BsCheck } from "react-icons/bs";

import Testemonials from '../Components/LandingPageComponents/Testemonials'
import CourseLeadFluency from '../Components/LandingPageComponents/CourseLeadFluency'
import Price from '../Components/LandingPageComponents/Price'
import VideoTestemonies from '../Components/LandingPageComponents/VideoTestemonies'
import LandingFooter from '../Components/LandingPageComponents/LandingFooter'
import EnrollBtn from '../Components/Buttons/EnrollBtn';
import CourseCardsGrid from '../Components/LandingPageComponents/CourseCardsGrid';
import { FaRegHandPointRight } from "react-icons/fa"
import BeforePrice from '../Components/LandingPageComponents/BeforePrice';
import CourseTools from '../Components/LandingPageComponents/CourseTools';
import MyProfile from '../Components/LandingPageComponents/MyProfile';
import NewsletterComponent from '../Components/Forms/NewsletterComponent';
import EBook from '../Components/EBook';
import NewsletterSubscriptionForm from '../Components/Forms/NewsletterSubscriptionForm';



function LandingPage() {
    return (
        <div className=' justify-center items-center flex flex-col w-full lg:min-w-[1000px]   sm:gap-0  bg-white'>
            <div className='flex flex-col md:flex-row sm:flex-row  z-8 w-full '>
                <div className=' bg-gradient-to-r from-violet-600 to-indigo-600 text-dk-purple pt-8 pb-8 px-2 flex lg:flex-row 
            flex-col md:items-center center lg:items-center lg:justify-around  w-full' >
                    <div className='  lg:w-[50%] flex flex-col lg:gap-16 text-white gap-6 py-4 md:pl-6 lf:pr-0 m md:pr-6 rounded-9 '>
                        <div className='lg:pt-16 flex flex-col '>
                            <h1 className='text-2xl md:text-3xl font-bold '>E-book Gratuito!!</h1>
                            <h2 className='text-xl'>📘 "Desbloqueie sua Fluência em Inglês!"!</h2>
                            <h2 className='mt-6 mb-3' >Baixe o meu e-book GRATUITAMENTE e dê o próximo passo rumo à fluência! </h2>
                            <NewsletterSubscriptionForm button={"Receber meu e-book"} />
                        </div>
                        <MyProfile />
                    </div>
                    <EBook />
                </div>

            </div>

            <CourseLeadFluency />
            <CourseCardsGrid />

            <Testemonials />
            <CourseTools />
            <VideoTestemonies />
            <div className='md:h-[20vh] h-[12vh]'></div>
            <LandingFooter />
            <NewsletterComponent />
        </div >


    )
}

export default LandingPage

